import { lazy } from 'react';
import BI0802R from "../../../routes/BI/BI0802R";
var CI2402R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI2402R");
});
var MC0101R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MC/MC0101R");
}); // const MC0102R = lazy(() => import("../../../routes/MC/MC0102R"));
var PC0101R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/PC/PC0101R");
}); // const CI0301R = lazy(() => import("../../../routes/CI/CI0301R"));
// const CI0401R = lazy(() => import("../../../routes/CI/CI0401R"));
var CI0302R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI0302R");
});
var CI0201R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI0201R");
});
var MI0101R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI0101R");
}); // const BI0401R = lazy(() => import("../../../routes/BI/BI0401R"));
var CI0101R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI0101R");
});
var MI0201R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI0201R");
});
var MI0301R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI0301R");
});
var MI0401R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI0401R");
});
var BI0301R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI0301R");
});
var BI0101R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI0101R");
}); // const CI0901R = lazy(() => import("../../../routes/CI/CI0901R"));
var MI0501R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI0501R");
});
var MI0601R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI0601R");
});
var MI1901R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI1901R");
});
var MI1902R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI1902R");
});
var CI1001R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI1001R");
});
var MI0801R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI0801R");
});
var MI0802R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI0802R");
});
var CI0701R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI0701R");
}); // const CI0303R = lazy(() => import("../../../routes/CI/CI0303R"));
var CI1201R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI1201R");
});
var BI0201R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI0201R");
});
var BI0501R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI0501R");
}); // const MI0102R = lazy(() => import("../../../routes/MI/MI0102R"));
var MI1001R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI1001R");
});
var BI0601R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI0601R");
});
var MI0502R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI0502R");
});
var MI1101R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI1101R");
});
var CI1601R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI1601R");
}); // const CI1701R = lazy(() => import("../../../routes/CI/CI1701R"));
var CI1801R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI1801R");
});
var CI1802R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI1802R");
});
var CI1803R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI1803R");
});
var MI0504R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI0504R");
});
var MI1401R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI1401R");
});
var BI0701R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI0701R");
});
var BI0702R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI0702R");
});
var BI0901R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI0901R");
});
var BI1001R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI1001R");
});
var BI1101R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI1101R");
});
var BI0703R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI0703R");
});
var MI1202R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI1202R");
}); // const CI0304R = lazy(() => import("../../../routes/CI/CI0304R"));
var CI2601R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI2601R");
});
var BI1301R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI1301R");
});
var MI1601R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI1601R");
});
var MI1701R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI1701R");
});
var MI0001R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI0001R");
});
var MI1801R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI1801R");
});
var MI1802R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI1802R");
});
var PC0402R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/PC/PC0402R");
}); // const PC0404R = lazy(() => import("../../../routes/PC/PC0404R"));
var PC0403R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/PC/PC0403R");
});
var PC0201R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/PC/PC0201R");
});
var PC0301R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/PC/PC0301R");
}); // const BI0001R = lazy(() => import("../../../routes/BI/BI0001R"));
var BI0801R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI0801R");
});
var BI1902R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/BI/BI1902R");
}); // const BI1904R = lazy(() => import("../../../routes/BI/BI1904R"));
var CI3201R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI3201R");
}); // const CI2704R = lazy(() => import("../../../routes/CI/CI2704R"));
var CI3301R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI3301R");
});
var MI2001R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI2001R");
});
var PC0501R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/PC/PC0501R");
});
var CI3101R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI3101R");
});
var CI2801R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI2801R");
});
var CI2802R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/CI/CI2802R");
});
var CI3001R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI3001R');
});
var MI2101R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/MI/MI2101R');
});
var BI2001R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/BI/BI2001R');
}); // const CI3401R = lazy(() => import('../../../routes/CI/CI3401R'));
var MI0803R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/MI/MI0803R');
});
var MI0804R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/MI/MI0804R');
});
var MI0805R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/MI/MI0805R');
});
var CI0702R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI0702R');
});
var CI3701R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI3701R');
});
var CI3801R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI3801R');
});
var CI3802R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI3802R');
});
var CI3803R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI3803R');
});
var CI1502R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI1502R');
});
var MI0104R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/MI/MI0104R');
}); // const CI0001R = lazy(() => import('../../../routes/CI/CI0001R'));
var CI0801R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI0801R');
});
var CI0601R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI0601R');
});
var CI0501R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI0501R');
});
var CI1503R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI1503R');
});
var CI3901R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI3901R');
});
var CI3902R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI3902R');
});
var CI4001R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI4001R');
});
var CI4101R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI4101R');
});
var BI2501R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/BI/BI2501R');
});
var MI2201R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/MI/MI2201R');
});
var CI3903R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI3903R');
});
var CI4201R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI4201R');
});
var CI4102R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI4102R');
});
var CI4103R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI4103R');
});
var CI4104R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI4104R');
});
var CI4105R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI4105R');
});
var CI4106R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI4106R');
});
var CI2603R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI2603R');
});
var CI2602R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI2602R');
});
var CI3702R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI3702R');
});
var CI4301R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI4301R');
});
var BI1202R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/BI/BI1202R');
});
var BI1203R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/BI/BI1203R');
});
var CI3703R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI3703R');
});
var CI1602R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI1602R');
});
var MI2202R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/MI/MI2202R');
});
var CI3704R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI3704R');
});
var CI0703R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI0703R');
});
var BI0202R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/BI/BI0202R');
}); // const MI0602R = lazy(() => import("../../../routes/MI/MI0602R"));
var MI2601R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/MI/MI2601R");
});
var PC0601R = /*#__PURE__*/lazy(function () {
  return import("../../../routes/PC/PC0601R");
});
var CI2604R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI2604R');
});
var MI0403R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/MI/MI0403R');
});
var CI0802R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI0802R');
});
var CI0804R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI0804R');
});
var CI0805R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI0805R');
});
var MI0604R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/MI/MI0604R');
});
var BI2502R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/BI/BI2502R');
});
var BI2503R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/BI/BI2503R');
}); //ci0202???
var CI0602R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI0602R');
});
var CI0502R = /*#__PURE__*/lazy(function () {
  return import('../../CI/CI2802/subComponents/Acl');
});
var CI2605R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI2605R');
});
var CI3907R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI3907R');
});
var CI3908R = /*#__PURE__*/lazy(function () {
  return import('../../../routes/CI/CI3908R');
});
var menuDict = {
  ci0801: {
    component: CI0801R,
    name: "首页",
    icon: "home"
  },
  ci2501: {
    component: MI1801R,
    name: "告警信息",
    sub: [{
      component: MI1802R,
      name: "告警信息详情",
      path: "/ci2501/mi1802"
    }]
  },
  ci4201: {
    component: CI4201R,
    name: "地图模式"
  },
  ci4102: {
    component: CI4102R,
    name: "基础防护"
  },
  ci4103: {
    component: CI4103R,
    name: "Wi-Fi配置"
  },
  ci4104: {
    component: CI4104R,
    name: "域名解析"
  },
  ci4105: {
    component: CI4105R,
    name: "多线路负载"
  },
  ci4106: {
    component: CI4106R,
    name: "多线路DNS代理"
  },
  ci0101: {
    component: CI0101R,
    name: "我的设备",
    sub: [
    //     {
    //     component: MI0102R, name: "设备详情", path: "/mi0101/mi0102"//none？
    // },
    {
      component: MI0104R,
      name: "APP设备详情",
      path: "/mi0101/mi0104"
    }]
  },
  ci2401: {
    component: MI1701R,
    name: "操作日志"
  },
  ci2101: {
    component: BI0901R,
    name: "中心节点"
  },
  ci2201: {
    component: BI1001R,
    name: "边缘节点"
  },
  ci2801: {
    component: CI2801R,
    name: "设备配置",
    sub: [{
      component: CI2802R,
      name: "客户详情",
      path: "/ci2801/ci2802"
    }]
  },
  ci3001: {
    component: CI3001R,
    name: "设备绑定"
  },
  bi2501: {
    component: BI2501R,
    name: "HA配置",
    sub: [{
      component: MI0502R,
      name: "链路信息详情",
      path: "/bi2501/bi0402"
    },
    // {
    //     component: MI0102R, name: "设备配置", path: "/bi2501/bi0302"
    // },
    {
      component: MI0104R,
      name: "APP设备详情",
      path: "/bi2501/mi0104"
    }]
  },
  ci0201: {
    component: CI0201R,
    name: "链路信息",
    sub: [{
      component: MI0502R,
      name: "链路信息",
      path: "/ci0201/mi0502"
    }]
  },
  bi1803: {
    component: CI0201R,
    name: "常规链路",
    sub: [{
      component: MI0502R,
      name: "链路信息",
      path: "/mi0501/mi0502"
    }]
  },
  bi1801: {
    component: BI0801R,
    name: "FullMesh链路",
    sub: [{
      component: BI0802R,
      name: "FullMesh链路详情",
      path: "/bi1801/bi1802"
    }]
  },
  ci1401: {
    component: BI0601R,
    name: "中心线路配置"
  },
  ci3701: {
    component: CI3701R,
    name: "客户端网段"
  },
  ci3702: {
    component: CI3702R,
    name: "客户端授权"
  },
  // ci0901: { component: CI0901R, name: "白名单" },
  ci3301: {
    component: CI3301R,
    name: "LAN模版"
  },
  ci3101: {
    component: CI3101R,
    name: "CPE模版"
  },
  ci3201: {
    component: CI3201R,
    name: "SSID模版"
  },
  ci0501: {
    component: CI0501R,
    name: "ACL配置"
  },
  ci0502: {
    component: CI0502R,
    name: "ACL2.0"
  },
  ci0601: {
    component: CI0601R,
    name: "隧道QoS"
  },
  ci0602: {
    component: CI0602R,
    name: "QoS2.0"
  },
  ci3901: {
    component: CI3901R,
    name: "互联网QoS"
  },
  ci4001: {
    component: CI4001R,
    name: "单IP限速"
  },
  // ci3902: { component: CI3902R, name: "应用限速" },
  ci4101: {
    component: CI4101R,
    name: "Mac访问控制"
  },
  ci1502: {
    component: CI1502R,
    name: "节点分组"
  },
  ci1503: {
    component: CI1503R,
    name: "域名分组"
  },
  ci1601: {
    component: CI1601R,
    name: "IP分组"
  },
  ci3801: {
    component: CI3801R,
    name: "自定义应用"
  },
  ci3802: {
    component: CI3802R,
    name: "系统应用"
  },
  ci3803: {
    component: CI3803R,
    name: "自定义分组"
  },
  //????????????
  // ci0401: { component: CI0401R, name: "日流量分析" },
  ci1801: {
    component: CI1801R,
    name: "4G卡登记",
    sub: [{
      component: CI1802R,
      name: "历史流量",
      path: "/ci1801/ci1802"
    }, {
      component: CI1801R,
      name: "分支流量",
      path: "/ci1801"
    }, {
      component: CI1803R,
      name: "4G流量统计",
      path: "/ci1803"
    }]
  },
  ci1201: {
    component: CI1201R,
    name: "客户Logo设置"
  },
  ci0701: {
    component: CI0701R,
    name: "运维账号"
  },
  ci0702: {
    component: CI0702R,
    name: "客户端账号"
  },
  ci1901: {
    component: BI0701R,
    name: "账期清单",
    sub: [{
      component: BI0703R,
      name: "查看账单",
      path: "/ci1901/bi0703"
    }]
  },
  ci1001: {
    component: CI1001R,
    name: "企业信息"
  },
  bi0301: {
    component: BI0301R,
    name: "设备列表",
    sub: [
    // {
    //     component: MI0102R, name: "设备配置", path: "/bi0301/bi0302"
    // },
    {
      component: MI0104R,
      name: "APP设备详情",
      path: "/mi0101/mi0104"
    }]
  },
  bi1601: {
    component: MI1701R,
    name: "操作日志"
  },
  bi0901: {
    component: BI0901R,
    name: "中心节点"
  },
  bi1001: {
    component: BI1001R,
    name: "边缘节点"
  },
  bi2201: {
    component: CI2801R,
    name: "设备配置",
    sub: [{
      component: CI2802R,
      name: "客户详情",
      path: "/ci2801/ci2802"
    }]
  },
  bi2301: {
    component: CI3001R,
    name: "设备绑定"
  },
  bi1101: {
    component: BI1101R,
    name: "常规链路",
    sub: [{
      component: MI0502R,
      name: "链路信息详情",
      path: "/bi0401/bi0402"
    }, {
      component: MI0504R,
      name: "智能去重",
      path: "/mi0501/mi0504"
    }]
  },
  bi0601: {
    component: BI0601R,
    name: "中心线路配置"
  },
  bi2102: {
    component: CI3301R,
    name: "LAN模版"
  },
  bi2103: {
    component: CI3101R,
    name: "CPE模版"
  },
  bi1902: {
    component: BI1902R,
    name: "SSID模版"
  },
  bi0501: {
    component: BI0501R,
    name: "流量分析"
  },
  // ci0303: {
  //     component: CI0303R,
  //     name: "DPI流量分析",
  //     sub: [{ component: CI0304R, name: "DPI流量", path: "/ci0303/ci0304" }]
  // },
  mi1401: {
    component: MI1401R,
    name: "链路负载率"
  },
  bi1201: {
    component: CI0701R,
    name: "客户账号"
  },
  bi0201: {
    component: BI0201R,
    name: "客户合同"
  },
  //？？？？？？？？
  bi0202: {
    component: BI0202R,
    name: "对账单"
  },
  mi1701: {
    component: MI1701R,
    name: "操作日志"
  },
  mi1801: {
    component: MI1801R,
    name: "告警信息",
    sub: [{
      component: MI1802R,
      name: "告警信息详情",
      path: "/mi1801/mi1802"
    }]
  },
  mi0101: {
    component: MI0101R,
    name: "设备列表",
    sub: [
    // {
    //     component: MI0102R, name: "设备详情", path: "/mi0101/mi0102"
    // },
    {
      component: MI0104R,
      name: "APP设备详情",
      path: "/mi0101/mi0104"
    }]
  },
  mc0101: {
    component: MC0101R,
    name: "任务信息"
  },
  // mc0102: { component: MC0102R, name: "任务信息(新)" },
  mi0601: {
    component: MI0601R,
    name: "POP点配置"
  },
  mi1901: {
    component: MI1901R,
    name: "Docker配置",
    sub: [{
      component: MI1902R,
      name: "Docker容器管理",
      path: "/mi1901/mi1902"
    } // { component: MI0102R, name: "设备详情", path: "/mi1901/mi1902/mi0102" },
    ]
  },
  mi0401: {
    component: MI0401R,
    name: "黑名单"
  },
  mi0402: {
    component: MI0401R,
    name: "关键词"
  },
  mi2201: {
    component: MI2201R,
    name: "资源库配置"
  },
  mi2101: {
    component: MI2101R,
    name: "POP点负载率"
  },
  mi0201: {
    component: MI0201R,
    name: "库存信息"
  },
  mi2001: {
    component: MI2001R,
    name: "出入库登记"
  },
  mi1601: {
    component: MI1601R,
    name: "出库统计"
  },
  mi0802: {
    component: MI0802R,
    name: "版本汇总"
  },
  mi0803: {
    component: MI0803R,
    name: "版本说明"
  },
  /* mi0901: {component: MI0901R, name: "设备报警"},*/mi0804: {
    component: MI0804R,
    name: "客户端版本"
  },
  mi0805: {
    component: MI0805R,
    name: "客户端升级"
  },
  mi0801: {
    component: MI0801R,
    name: "版本更新"
  },
  //???版本更新
  mi0301: {
    component: MI0301R,
    name: "机房信息"
  },
  mi1101: {
    component: MI1101R,
    name: "运营商信息"
  },
  mi1001: {
    component: MI1001R,
    name: "关系人信息"
  },
  pc0101: {
    name: "账号管理",
    component: PC0101R
  },
  pc0201: {
    name: "密码管理",
    component: PC0201R
  },
  pc0301: {
    name: "操作日志",
    component: PC0301R
  },
  pc0402: {
    component: PC0402R,
    name: "CPE型号"
  },
  pc0403: {
    component: PC0403R,
    name: "区域设置"
  },
  // pc0404: { component: PC0404R, name: "大区设置" },
  pc0501: {
    component: PC0501R,
    name: "授权管理"
  },
  mi0001: {
    component: MI0001R,
    name: "首页"
  },
  bi0101: {
    name: "首页",
    component: BI0101R,
    sub: [{
      component: CI1001R,
      name: "客户详情",
      path: "/bi0101/bi0102"
    } // { component: BI0103R, name: "客户详情", path: "/bi0101/bi0103" },
    // { component: BI0001R, name: "客户详情", path: "/bi0101/bi0001" },
    ]
  },
  // ci3401: { component: CI3401R, name: "互联网访问策略" },
  ci2601: {
    component: CI2601R,
    name: "告警接收"
  },
  ci2602: {
    component: CI2602R,
    name: "告警事件"
  },
  ci2603: {
    component: CI2603R,
    name: "告警配置"
  },
  ci0302: {
    component: CI0302R,
    name: "流量分析(隧道内)"
  },
  ci2402: {
    component: CI2402R,
    name: "用户访问日志"
  },
  ci3903: {
    component: CI3903R,
    name: "目标引流"
  },
  ci4301: {
    component: CI4301R,
    name: "我的客户端"
  },
  bi1301: {
    component: BI1301R,
    name: "系统应用"
  },
  bi1202: {
    component: BI1202R,
    name: "客户联系人"
  },
  bi0701: {
    component: BI0701R,
    name: "账期管理",
    sub: [{
      component: BI0702R,
      name: "修改账期",
      path: "/bi0701/bi0702"
    }, {
      component: BI0703R,
      name: "查看账单",
      path: "/bi0701/bi0703"
    }, {
      component: MI0502R,
      name: "链路信息",
      path: "/bi0701/bi0704"
    }]
  },
  mi0501: {
    component: MI0501R,
    name: "链路信息",
    sub: [{
      component: MI0502R,
      name: "链路信息",
      path: "/mi0501/mi0502"
    }, {
      component: MI0504R,
      name: "智能去重",
      path: "/mi0501/mi0504"
    }]
  },
  mi1202: {
    component: MI1202R,
    name: "压缩流量分析"
  },
  bi1203: {
    component: BI1203R,
    name: "登录背景图设置"
  },
  ci3703: {
    component: CI3703R,
    name: "Mac认证"
  },
  ci1602: {
    component: CI1602R,
    name: "用户分组"
  },
  mi2202: {
    component: MI2202R,
    name: "资源分组"
  },
  ci3704: {
    component: CI3704R,
    name: "SaaS访问权限"
  },
  bi2001: {
    component: BI2001R,
    name: "上云申请"
  },
  ci0703: {
    component: CI0703R,
    name: "客户端链路"
  },
  ci1803: {
    component: CI1803R,
    name: "4G流量统计"
  },
  // mi0602: {component: MI0602R, name: "专家路策略"},
  mi2601: {
    component: MI2601R,
    name: "告警接收"
  },
  pc0601: {
    component: PC0601R,
    name: "控制器管理"
  },
  ci3904: {
    component: CI3903R,
    name: "源地址引流"
  },
  ci2604: {
    component: CI2604R,
    name: "屏蔽策略"
  },
  ci3705: {
    component: CI3704R,
    name: "移动客户端"
  },
  ci3905: {
    component: CI3903R,
    name: "CPE设备"
  },
  ci1603: {
    component: CI1503R,
    name: "静态解析分组"
  },
  mi0403: {
    component: MI0403R,
    name: "域名关键词配置"
  },
  ci3906: {
    component: CI3902R,
    name: "IP限速"
  },
  ci0802: {
    component: CI0802R,
    name: "地图模式"
  },
  ci0804: {
    component: CI0804R,
    name: "专线资源"
  },
  ci0805: {
    component: CI0805R,
    name: "任务中心"
  },
  mi0604: {
    component: MI0604R,
    name: "预制路径标签"
  },
  bi2502: {
    component: BI2502R,
    name: "出口方向"
  },
  bi2503: {
    component: BI2503R,
    name: "链路带宽"
  },
  ci2605: {
    component: CI2605R,
    name: "告警模版"
  },
  ci3907: {
    component: CI3907R,
    name: "IP限速2.0"
  },
  ci3908: {
    component: CI3908R,
    name: "代理优化"
  }
};
export { menuDict };